export function configBool(
  value: string | boolean | undefined,
  defaultValue = false,
): boolean {
  if (value === undefined || value === null) {
    return defaultValue;
  }
  if (typeof value === 'boolean') {
    return value;
  }
  return value === 'true';
}
